const genId = () =>
  Math.random()
    .toString(36)
    .substring(7);

export const systemCorrelationId = `1_1492561111_766_48_${genId()}_CHECKOUT-WIDGET`;
export const systemSessionId = {
  create: () => `vme_prod_001${genId()}`
};
